module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-backward-btn-fill-0bde7227.svg";